import dayjs, { ConfigType } from "dayjs";

// Reads the currently active UI language from the L10nPlugin localStorage key
// Falls back to "en" when unavailable.

export function getCurrentLanguage(): string {
  try {
    return (
      (typeof window !== "undefined" && window.localStorage
        ? window.localStorage.getItem("language")
        : null) || "en"
    );
  } catch {
    return "en";
  }
}

/**
 * Consistent date formatting for UI display.
 * - EN: "25 Apr 2026"
 * - DE: "25.04.2026"
 * Returns an empty string when the input is not a valid date.
 */
export function formatDate(value: ConfigType, language?: string): string {
  const d = dayjs(value);
  if (!value || !d.isValid()) return "";
  const lang = (language || getCurrentLanguage()).toLowerCase();
  return lang.startsWith("de")
    ? d.format("DD.MM.YYYY")
    : d.format("DD MMM YYYY");
}

export function getDateInputFormat(language?: string): string {
  const lang = (language || getCurrentLanguage()).toLowerCase();
  return lang.startsWith("de") ? "DD.MM.YYYY" : "DD MMM YYYY";
}

export function formatDateTime(value: ConfigType, language?: string): string {
  const d = dayjs(value);
  if (!value || !d.isValid()) return "";
  const lang = (language || getCurrentLanguage()).toLowerCase();
  return lang.startsWith("de")
    ? d.format("DD.MM.YYYY, HH:mm")
    : d.format("DD MMM YYYY, HH:mm");
}
